import { Box, LinearProgress, Typography } from '@mui/material';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';

const requirements = [
  { label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { label: 'One uppercase letter (A–Z)', test: (p) => /[A-Z]/.test(p) },
  { label: 'One lowercase letter (a–z)', test: (p) => /[a-z]/.test(p) },
  { label: 'One number (0–9)', test: (p) => /[0-9]/.test(p) },
];

const strengthConfig = [
  { label: 'Too short',  color: 'error' },
  { label: 'Weak',       color: 'error' },
  { label: 'Fair',       color: 'warning' },
  { label: 'Good',       color: 'warning' },
  { label: 'Strong',     color: 'success' },
];

const PasswordStrengthIndicator = ({ password }) => {
  if (!password) return null;

  const met = requirements.filter((r) => r.test(password)).length;
  const config = strengthConfig[met];
  const percent = (met / requirements.length) * 100;

  return (
    <Box sx={{ mt: 1, mb: 0.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <LinearProgress
          variant="determinate"
          value={percent}
          color={config.color}
          sx={{ flex: 1, height: 6, borderRadius: 3 }}
        />
        <Typography variant="caption" color={`${config.color}.main`} fontWeight="medium" sx={{ minWidth: 48 }}>
          {config.label}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
        {requirements.map((req) => {
          const passed = req.test(password);
          return (
            <Box key={req.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {passed
                ? <CheckCircle sx={{ fontSize: 14 }} color="success" />
                : <RadioButtonUnchecked sx={{ fontSize: 14 }} color="disabled" />
              }
              <Typography variant="caption" color={passed ? 'success.main' : 'text.secondary'}>
                {req.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default PasswordStrengthIndicator;
